import React from "react";
import { Autocomplete, TextField, Chip, Checkbox } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

interface MultiSelectDropdownProps {
  options: string[];
  value: string[];
  onChange: (newValue: string[]) => void;
  label?: string;
  placeholder?: string;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  value,
  onChange,
  label = "Select Options",
  placeholder = "Search...",
}) => {
  const SELECT_ALL = "__SELECT_ALL__";

  const allOptions = [SELECT_ALL, ...options];

  const handleChange = (event: any, newValue: string[]) => {
    if (newValue.includes(SELECT_ALL)) {
      if (value.length === options.length) {
        // Deselect all
        onChange([]);
      } else {
        // Select all
        onChange([...options]);
      }
    } else {
      onChange(newValue);
    }
  };

  const isAllSelected = value.length === options.length;

  return (
    <Autocomplete
      sx={{ my: 2 }}
      multiple
      options={allOptions}
      value={value}
      onChange={handleChange}
      disableCloseOnSelect
      filterSelectedOptions
      getOptionLabel={(option) =>
        option === SELECT_ALL
          ? isAllSelected
            ? "Deselect All"
            : "Select All"
          : option
      }
      renderOption={(props, option, { selected }) => {
        const isSelectAll = option === SELECT_ALL;
        const isChecked = isSelectAll ? isAllSelected : selected;

        return (
          <li {...props}>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              style={{ marginRight: 8 }}
              checked={isChecked}
            />
            {option === SELECT_ALL
              ? isAllSelected
                ? "Deselect All"
                : "Select All"
              : option}
          </li>
        );
      }}
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip label={option} {...getTagProps({ index })} size="small" />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default MultiSelectDropdown;
